import { PlanningActionsDtoModelType, PlanningActionsStatus, PlanningActionMetadataDtoModelType } from '../../../models';
import optimizeHandler from './optimizeHandler';
import ordersToTargetRoutesHandler from './ordersToTargetRoutesHandler';
import duplicateRouteHandler from './duplicateRouteHandler';
import deleteRoutesHandler from './deleteRoutesHandler';
import defaultHandler from './defaultHandler';
import getAppRoot from '../../../utils/getAppRoot';

type PlanningActionHandler = (action: PlanningActionMetadataDtoModelType) => void | (() => Promise<void>);

const isAsyncFunction = (result: void | (() => Promise<void>)): result is () => Promise<void> => {
  return typeof result === 'function';
};

export const restoreActiveActions = async (
  activePlanningActions: PlanningActionsDtoModelType[],
  store: any,
) => {
  if (!activePlanningActions?.length) {
    return;
  }

  const appStore = getAppRoot(store);
  const projectId = appStore.ui.selectedWorkspace?.id;

  if (!projectId) {
    return;
  }

  const actionsToRestore = activePlanningActions.filter(
    (action) =>
      (action.status === PlanningActionsStatus.NOT_STARTED ||
        action.status === PlanningActionsStatus.IN_PROGRESS) &&
      String(action.projectId) === projectId,
  );

  for (const action of actionsToRestore) {
    const actionName = action.actionName;
    let handler: PlanningActionHandler;

    if (actionName === 'OptimizeDate' || actionName === 'ReOptimize' || actionName === 'DrawRoute') {
      handler = optimizeHandler;
    } else if (actionName === 'OptimizeOrdersToTargetRoutes' || actionName === 'MoveOrdersToRoutes') {
      handler = ordersToTargetRoutesHandler;
    } else if (actionName === 'DuplicateRouteAndOrders') {
      handler = duplicateRouteHandler;
    } else if (actionName === 'DeleteRoutes') {
      handler = deleteRoutesHandler;
    } else {
      handler = defaultHandler;
    }

    const actionWithStore: PlanningActionMetadataDtoModelType = {
      actionUuid: action.actionUuid!,
      projectId: action.projectId,
      startDate: action.startDate,
      actionName: action.actionName!,
      status: action.status,
      userUuid: action.userUuid!,
      output: action.output,
      detail: action.detail,
      organizationId: action.organizationId,
      createdAt: action.createdAt,
      updatedAt: action.updatedAt,
      finishedAt: action.finishedAt,
      isUndo: undefined,
      isRedo: undefined,
      childActions: action.childActions,
      store,
    } as PlanningActionMetadataDtoModelType;

    try {
      const handlerResult = handler(actionWithStore);
      if (isAsyncFunction(handlerResult)) {
        await handlerResult();
      }
    } catch (error) {
      console.error(`Failed to restore action ${action.actionUuid}:`, error);
    }
  }
};

